import { ApiResourceBaseClass as c } from "./baseApiCalls.js";
const s = "sections", n = "groups";
class $ extends c {
  /**
   * Fetches sections based on the provided query parameters.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/sections`
   *
   * @param {GetSectionsParams} queryParams - Parameters used to filter or configure the section retrieval.
   * @returns {Promise<GetSectionsReceivedData>} A promise resolving to the data containing the sections.
   */
  getSections = async (t) => {
    const { data: a } = await this.get(
      s,
      t
    );
    return a;
  };
  /**
   * Retrieves details of a specific section by its ID.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/sections/{sectionId}`
   *
   * @param {string} sectionId - The unique identifier of the section to retrieve.
   * @returns {Promise<GroupSection>} A promise resolving to the data of the requested section.
   */
  getSection = async (t) => {
    const { data: a } = await this.get(`${s}/${t}`);
    return a;
  };
  /**
   * Creates a new section with the given name.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/sections`
   *
   * @param {CreateSectionParams} body - The name, and optionally the org_id of the section to create.
   * @returns {Promise<CreateUpdateDeleteReceivedData>} A promise resolving to the response data, including the ID of the newly created section.
   */
  createSection = async (t) => {
    const { data: a } = await this.post(
      s,
      t
    );
    return a;
  };
  /**
   * Updates the section with the given section ID.
   *
   * @param {string} sectionId - The unique identifier of the section to be updated.
   * @param {UpdateSectionParams} body - Conatains the new name of the section, and optionally the new org_id.
   * @returns {Promise<CreateUpdateDeleteReceivedData>} A promise resolving to the response data, including the ID of the updated section.
   */
  updateSection = async (t, a) => {
    const { data: e } = await this.post(
      `${s}/${t}`,
      a
    );
    return e;
  };
  /**
   * Deletes the section with the given section ID.
   *
   * @param sectionId - The unique identifier of the section to be deleted.
   * @returns {Promise<CreateUpdateDeleteReceivedData>} A promise resolving to the response data, including the ID of the deleted section.
   */
  deleteSection = async (t) => {
    const { data: a } = await this.delete(
      `${s}/${t}`
    );
    return a;
  };
  /**
   * Fetches group based on the provided section ID and group ID.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/sections/{sectionId}/groups/{groupId}`
   *
   * @param {string} sectionId - The unique identifier of the section of the group to retrieve.
   * @param {string} groupId - The unique identifier of the group to retrieve.
   * @returns {Promise<GroupObject>} A promise resolving to the group data, including `business_id`s of businesses in the group.
   */
  getGroup = async (t, a) => {
    const { data: e } = await this.get(
      `${s}/${t}/${n}/${a}`
    );
    return e;
  };
  /**
   * Creates a new group, containing the given businesses, in the section with the given section ID.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/sections/{sectionId}/groups`
   *
   * @param {string} sectionId - The unique identifier of the section in which to create the new group.
   * @param {CreateGroupParams} body - The name of the group, and a list of the IDs of the businesses to include in the group (list can be empty).
   * @returns {Promise<CreateUpdateDeleteReceivedData>} A promise resolving to the response data, including the ID of the newly created group.
   */
  createGroup = async (t, a) => {
    const { data: e } = await this.post(
      `${s}/${t}/${n}`,
      a
    );
    return e;
  };
  /**
   * Updates the group with the given group ID in the section with the given section ID.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/sections/{sectionId}/groups/{groupId}`
   *
   * @param {string} sectionId - The unique identifier of the section in which the group is located.
   * @param {string} groupId - The unique identifier of the group to be updated.
   * @param {CreateGroupParams} body - The new name of the group, and a list of the IDs of the businesses to include in the group (list can be empty).
   * @returns {Promise<CreateUpdateDeleteReceivedData>} A promise resolving to the response data, including the ID of the updated group.
   */
  updateGroup = async (t, a, e) => {
    const { data: o } = await this.post(
      `${s}/${t}/${n}/${a}`,
      e
    );
    return o;
  };
  /**
   * Deletes the group with the given group ID in the section with the given section ID.
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/sections/{sectionId}/groups/{groupId}`
   *
   * @param {string} sectionId - The unique identifier of the section in which the group is located.
   * @param {string} groupId - The unique identifier of the group to be deleted.
   * @returns {Promise<CreateUpdateDeleteReceivedData>} - A promise resolving to the response data, including the ID of the newly deleted group.
   */
  deleteGroup = async (t, a) => {
    const { data: e } = await this.delete(
      `${s}/${t}/${n}/${a}`
    );
    return e;
  };
}
export {
  $ as Group
};
